export default __webpack_public_path__ + "static/media/cta-background-small.1f1790a0.jpg";